import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FaAngleRight, FaAngleLeft, FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const ModalCopiarHierarquia = function (props) {
  const mostrar = props.mostrar;
  const onFechar = props.onFechar;
  const onConcluido = props.onConcluido;
  const gesHierarquia = props.gesHierarquia;

  const _s = function (val) { return useState(val); };

  const geOrigemState = _s(null);
  const geOrigem = geOrigemState[0]; const setGeOrigem = geOrigemState[1];
  const gesDisponiveisState = _s([]);
  const gesDisponiveis = gesDisponiveisState[0]; const setGesDisponiveis = gesDisponiveisState[1];
  const gesSelecionadosState = _s([]);
  const gesSelecionados = gesSelecionadosState[0]; const setGesSelecionados = gesSelecionadosState[1];
  const geDestinoFiltroState = _s(null);
  const geDestinoFiltro = geDestinoFiltroState[0]; const setGeDestinoFiltro = geDestinoFiltroState[1];
  const copiandoState = _s(false);
  const copiando = copiandoState[0]; const setCopiando = copiandoState[1];
  const contasAusentesState = _s(null);
  const contasAusentes = contasAusentesState[0]; const setContasAusentes = contasAusentesState[1];
  const confirmacaoState = _s({ show: false, callback: null });
  const confirmacao = confirmacaoState[0]; const setConfirmacao = confirmacaoState[1];

  // Selecao na lista de disponiveis
  const selDispState = _s([]);
  const selDisp = selDispState[0]; const setSelDisp = selDispState[1];
  const selSelecionadosState = _s([]);
  const selSelecionados = selSelecionadosState[0]; const setSelSelecionados = selSelecionadosState[1];

  // Quando GE origem muda, popula disponiveis
  useEffect(function () {
    setGesSelecionados([]);
    setSelDisp([]);
    setSelSelecionados([]);
    setGeDestinoFiltro(null);
    setContasAusentes(null);

    if (!geOrigem) {
      setGesDisponiveis([]);
      return;
    }
    const filtrados = gesHierarquia.filter(function (ge) {
      return ge.value !== geOrigem.value;
    });
    setGesDisponiveis(filtrados);
  }, [geOrigem, gesHierarquia]);

  const handleMoverDireita = function () {
    if (selDisp.length === 0) return;
    const selecionadosValues = selDisp.map(function (ge) { return ge.value; });
    setGesSelecionados(function (prev) { return prev.concat(selDisp); });
    setGesDisponiveis(function (prev) {
      return prev.filter(function (ge) { return selecionadosValues.indexOf(ge.value) < 0; });
    });
    setSelDisp([]);
  };

  const handleMoverEsquerda = function () {
    if (selSelecionados.length === 0) return;
    const selecionadosValues = selSelecionados.map(function (ge) { return ge.value; });
    setGesDisponiveis(function (prev) { return prev.concat(selSelecionados); });
    setGesSelecionados(function (prev) {
      return prev.filter(function (ge) { return selecionadosValues.indexOf(ge.value) < 0; });
    });
    setSelSelecionados([]);
  };

  const handleMoverTodosDireita = function () {
    setGesSelecionados(function (prev) { return prev.concat(gesDisponiveis); });
    setGesDisponiveis([]);
    setSelDisp([]);
  };

  const handleMoverTodosEsquerda = function () {
    setGesDisponiveis(function (prev) { return prev.concat(gesSelecionados); });
    setGesSelecionados([]);
    setSelSelecionados([]);
  };

  const toggleSelDisp = function (ge) {
    setSelDisp(function (prev) {
      const exists = prev.find(function (g) { return g.value === ge.value; });
      if (exists) return prev.filter(function (g) { return g.value !== ge.value; });
      return prev.concat([ge]);
    });
  };

  const toggleSelSelecionados = function (ge) {
    setSelSelecionados(function (prev) {
      const exists = prev.find(function (g) { return g.value === ge.value; });
      if (exists) return prev.filter(function (g) { return g.value !== ge.value; });
      return prev.concat([ge]);
    });
  };

  // Locate via select
  const handleLocateGe = function (opt) {
    setGeDestinoFiltro(opt);
    if (!opt) return;
    // Move o GE localizado para selecionados se esta em disponiveis
    const found = gesDisponiveis.find(function (ge) { return ge.value === opt.value; });
    if (found) {
      setGesSelecionados(function (prev) { return prev.concat([found]); });
      setGesDisponiveis(function (prev) { return prev.filter(function (ge) { return ge.value !== opt.value; }); });
      setGeDestinoFiltro(null);
    }
  };

  const handleLimpar = function () {
    setGeOrigem(null);
    setGesSelecionados([]);
    setGesDisponiveis([]);
    setSelDisp([]);
    setSelSelecionados([]);
    setContasAusentes(null);
    setGeDestinoFiltro(null);
  };

  const handleCopiar = async function () {
    if (!geOrigem) {
      toast.warn('Selecione um GE de origem.');
      return;
    }
    if (gesSelecionados.length === 0) {
      toast.warn('Selecione pelo menos um GE de destino.');
      return;
    }

    setCopiando(true);
    setContasAusentes(null);

    try {
      const destinos = gesSelecionados.map(function (ge) { return ge.value; });
      const validacao = await api.validarCopiaHierarquia({
        ge_origem: geOrigem.value,
        ges_destino: destinos,
      });

      if (!validacao.valido) {
        setContasAusentes(validacao.contas_ausentes);
        setCopiando(false);
        return;
      }

      setCopiando(false);
      setConfirmacao({
        show: true,
        callback: async function (confirmado) {
          setConfirmacao({ show: false, callback: null });
          if (!confirmado) return;
          setCopiando(true);
          try {
            await api.copiarHierarquiaMassa({
              ge_origem: geOrigem.value,
              ges_destino: destinos,
            });
            onConcluido();
          } catch (err) {
            const msg = (err && err.response && err.response.data) || (err && err.message) || 'Erro na cópia em massa.';
            toast.error(typeof msg === 'string' ? msg : 'Erro na cópia em massa.');
          }
          setCopiando(false);
        },
      });
    } catch (err) {
      const msg = (err && err.response && err.response.data) || (err && err.message) || 'Erro ao validar cópia.';
      toast.error(typeof msg === 'string' ? msg : 'Erro ao validar cópia.');
      setCopiando(false);
    }
  };

  const optsGeOrigem = gesHierarquia;
  const optsLocate = gesDisponiveis;
  const desabilitado = !geOrigem;

  return (
    <>
      <Modal show={mostrar} onHide={onFechar} size="lg" centered backdrop="static">
        <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <Modal.Title>Copiar Hierarquia em Massa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col md={6}>
              <label className="mb-1"><strong>GE de Origem:</strong></label>
              <Select
                placeholder="Selecione o GE de origem..."
                options={optsGeOrigem}
                value={geOrigem}
                onChange={setGeOrigem}
                isClearable
                menuPortalTarget={document.body}
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
          </Row>

          <div style={{ opacity: desabilitado ? 0.5 : 1, pointerEvents: desabilitado ? 'none' : 'auto' }}>
            <Row className="mb-2">
              <Col>
                <label className="mb-1"><strong>Localizar GE de Destino:</strong></label>
                <Select
                  placeholder="Buscar GE para adicionar..."
                  options={optsLocate}
                  value={geDestinoFiltro}
                  onChange={handleLocateGe}
                  isClearable
                  menuPortalTarget={document.body}
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                />
              </Col>
            </Row>

            <Row>
              {/* Lista Disponiveis */}
              <Col md={5}>
                <label className="mb-1"><strong>Disponíveis ({gesDisponiveis.length})</strong></label>
                <div className="hc-dual-list-container">
                  <Table striped bordered hover size="sm" className="mb-0">
                    <thead>
                      <tr><th style={{ width: '50px' }}>GE</th><th>Apelido</th></tr>
                    </thead>
                    <tbody>
                      {gesDisponiveis.length === 0 ? (
                        <tr><td colSpan="2" className="text-center text-muted">Nenhum GE disponível</td></tr>
                      ) : (
                        gesDisponiveis.map(function (ge) {
                          const selected = selDisp.find(function (g) { return g.value === ge.value; });
                          return (
                            <tr
                              key={ge.value}
                              onClick={function () { toggleSelDisp(ge); }}
                              onDoubleClick={function () {
                                setGesSelecionados(function (prev) { return prev.concat([ge]); });
                                setGesDisponiveis(function (prev) { return prev.filter(function (g) { return g.value !== ge.value; }); });
                                setSelDisp(function (prev) { return prev.filter(function (g) { return g.value !== ge.value; }); });
                              }}
                              style={{ cursor: 'pointer', backgroundColor: selected ? '#cce5ff' : undefined }}
                            >
                              <td>{ge.value}</td>
                              <td>{ge.label.split(' - ').slice(1).join(' - ')}</td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>

              {/* Botoes transferencia */}
              <Col md={2} className="d-flex flex-column align-items-center justify-content-center">
                <Button size="sm" variant="outline-primary" className="mb-1" onClick={handleMoverDireita} disabled={selDisp.length === 0} title="Mover selecionados"><FaAngleRight /></Button>
                <Button size="sm" variant="outline-primary" className="mb-1" onClick={handleMoverEsquerda} disabled={selSelecionados.length === 0} title="Remover selecionados"><FaAngleLeft /></Button>
                <Button size="sm" variant="outline-primary" className="mb-1" onClick={handleMoverTodosDireita} disabled={gesDisponiveis.length === 0} title="Mover todos"><FaAngleDoubleRight /></Button>
                <Button size="sm" variant="outline-primary" onClick={handleMoverTodosEsquerda} disabled={gesSelecionados.length === 0} title="Remover todos"><FaAngleDoubleLeft /></Button>
              </Col>

              {/* Lista Selecionados */}
              <Col md={5}>
                <label className="mb-1"><strong>Selecionados ({gesSelecionados.length})</strong></label>
                <div className="hc-dual-list-container">
                  <Table striped bordered hover size="sm" className="mb-0">
                    <thead>
                      <tr><th style={{ width: '50px' }}>GE</th><th>Apelido</th></tr>
                    </thead>
                    <tbody>
                      {gesSelecionados.length === 0 ? (
                        <tr><td colSpan="2" className="text-center text-muted">Nenhum GE selecionado</td></tr>
                      ) : (
                        gesSelecionados.map(function (ge) {
                          const selected = selSelecionados.find(function (g) { return g.value === ge.value; });
                          return (
                            <tr
                              key={ge.value}
                              onClick={function () { toggleSelSelecionados(ge); }}
                              onDoubleClick={function () {
                                setGesDisponiveis(function (prev) { return prev.concat([ge]); });
                                setGesSelecionados(function (prev) { return prev.filter(function (g) { return g.value !== ge.value; }); });
                                setSelSelecionados(function (prev) { return prev.filter(function (g) { return g.value !== ge.value; }); });
                              }}
                              style={{ cursor: 'pointer', backgroundColor: selected ? '#cce5ff' : undefined }}
                            >
                              <td>{ge.value}</td>
                              <td>{ge.label.split(' - ').slice(1).join(' - ')}</td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>

            {/* Contas ausentes */}
            {contasAusentes && contasAusentes.length > 0 && (
              <div className="mt-3">
                <div className="alert alert-danger">
                  <strong>Operação bloqueada.</strong> As contas abaixo não existem nos GEs destino:
                  <Table striped bordered size="sm" className="mt-2 mb-0">
                    <thead><tr><th>GE Destino</th><th>Conta</th><th>Nome</th></tr></thead>
                    <tbody>
                      {contasAusentes.map(function (c, i) {
                        return <tr key={i}><td>{c.ge_destino}</td><td>{c.codigo_conta}</td><td>{c.apelido_conta}</td></tr>;
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCopiar} disabled={copiando}>
            {copiando ? 'Copiando...' : 'Copiar'}
          </Button>
          <Button variant="secondary" onClick={handleLimpar}>Limpar</Button>
        </Modal.Footer>
      </Modal>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Cópia Destrutiva em Massa"
        message={'Confirma copiar a hierarquia do GE ' + (geOrigem ? geOrigem.label : '') + ' para ' + gesSelecionados.length + ' GEs? Esta operação APAGARÁ a hierarquia existente nos GEs destino.'}
        onClose={confirmacao.callback || function () { setConfirmacao({ show: false, callback: null }); }}
      />
    </>
  );
};

export default ModalCopiarHierarquia;
